import { SidebarItem } from "@backstage/core-components";
import { SWA_GATE, SWA_OWNER_PAGE_PATH } from "@internal/backstage-plugin-avd-common";
import WebOutlinedIcon from "@material-ui/icons/WebOutlined";
import { PropsWithChildren } from "react";

import { RequireEntitled, type PageHeroText } from "../avd/avdEntitlement";
import { useEntitled } from "../identity/ownership";

/** The page's own hero; the request-access page repeats it so the two introduce themselves alike. */
export const MY_WEB_APPS_HERO: PageHeroText = {
	eyebrow: "My web apps · one per project",
	title: "My web apps",
};
/** The forms under My web apps. */
export const MY_WEB_APPS_NEW_PATH = `${SWA_OWNER_PAGE_PATH}/new`;
export const MY_WEB_APPS_DELETE_PATH = `${SWA_OWNER_PAGE_PATH}/delete`;

/** The delete form with the project number filled in; the colleague still types it again to confirm. */
export const deleteWebAppPath = (projectNumber: string) =>
	`${MY_WEB_APPS_DELETE_PATH}?formData=${encodeURIComponent(JSON.stringify({ projectNumber }))}`;

export const MY_WEB_APPS_TITLE = MY_WEB_APPS_HERO.title;
export const MY_WEB_APPS_SUBTITLE = "Your websites with a database, one per project";

/** "My web apps" sidebar item, rendered only for SWA-entitled users (UX only; the policy enforces). */
export const WebAppsSidebarItem = () => {
	const { member } = useEntitled(SWA_GATE);
	return member ? (
		<SidebarItem icon={WebOutlinedIcon} to={SWA_OWNER_PAGE_PATH.slice(1)} text="My web apps" />
	) : null;
};

/** Route guard for My web apps: non-members get the request-access card naming the SWA group. */
export const RequireSwaEntitled = ({ children }: PropsWithChildren<{}>) => (
	<RequireEntitled gate={SWA_GATE} hero={MY_WEB_APPS_HERO} what="web apps">
		{children}
	</RequireEntitled>
);
